import React from "react";

export const Navigation = ({ servicesData }) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
            TOMEDYUS MEDİKAL
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li className="services-nav-item">
              <a href="#services" className="page-scroll">
                HİZMETLERİMİZ
                {servicesData?.length ? (
                  <span className="services-nav-item__chevron">▾</span>
                ) : null}
              </a>

              {servicesData?.length ? (
                <ul className="services-dropdown">
                  {servicesData.map((d, i) => (
                    <li key={`nav-service-${d.title}-${i}`}>
                      <a href={`#service-${i + 1}`} className="page-scroll">
                        {d.title}
                      </a>
                    </li>
                  ))}
                </ul>
              ) : null}
            </li>

            <li>
              <a href="#about" className="page-scroll">
                HAKKIMIZDA
              </a>
            </li>

            <li>
              <a href="#contact" className="page-scroll">
                İLETİŞİM
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
